<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">
        <!-- <pre>{{selected}}</pre> -->
        <!-- <div class="flex flex-wrap items-center justify-between">
          <vx-input-group class="mb-base mr-3">
            <vs-input v-model="mailTo" placeholder="Email" />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button type="border" @click="mailTo = ''" class="whitespace-no-wrap">Send PO Trigger</vs-button>
              </div>
            </template>
          </vx-input-group>
          <div class="flex items-center">
            <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-download">Download</vs-button>
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="print">Print</vs-button>
          </div>
        </div> -->

        <vx-card>
            <!-- <pre>{{selected}}</pre> -->
            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-full md:w-1/2 mt-base">
                    <div class="vx-logo cursor-pointer flex items-center">
                        <img :src="logo" alt="logo" class="w-10 mr-4" v-if="logo">
                        <img :src="partnerLogo" alt="partner-logo" class="w-10 mr-4" v-if="hasPartner && (logo !== partnerLogo)">
                    </div>
                    <img :src="fullLogo" alt="full-logo" v-if="hasLogoFull">
                    <!-- <img :src="fullLogo" alt="logo" class="mr-4"><img v-if="hasPartner" :src="partnerLogo" alt="logo"> -->
                </div>
                <div class="vx-col w-full md:w-1/2 text-right">
                    <h1>Purchase Trigger</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h6>TRIGGER NO.</h6>
                        <p>{{ invoiceDetails.invoiceNo }}</p>

                        <h6 class="mt-4">TRIGGER DATE</h6>
                        <p>{{ invoiceDetails.invoiceDate | date(true) }}</p>
                    </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mt-12">
                    <h5>Order Details</h5>
                    <div class="invoice__recipient-info my-4">
                        <p>No of Items in this PO Trigger   : <span class="font-bold">{{selected.length | numFormat}}</span></p>
                        <p>Total Value of Order             : <span class="font-bold">{{calculateCtc() | numFormat('$ 0,0')}}</span></p>
                        <p>Service Level                    : <span class="font-bold">{{service.actual | numFormat}}</span>%</p>
                    </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mt-base text-right mt-12">
                    <div>
                        <div class="flex items-center justify-end">
                            <vs-button
                                type="filled"
                                color="primary"
                                gradient-color-secondary="rgb(130, 207, 23)"
                                icon-pack="feather"
                                icon="icon-printer"
                                class="mr-3"
                                @click="print"
                            >Print</vs-button>
                            <vs-button
                                type="filled"
                                color="primary"
                                gradient-color-secondary="rgb(130, 207, 23)"
                                icon-pack="feather"
                                icon="icon-radio"
                                @click="trigger()"
                            >PO Trigger</vs-button>
                        </div>
                    </div> 
                </div>
            </div>

            <vs-table  max-items="100" pagination :data="getData()">
                <template slot="thead">
                    <vs-th>Channel</vs-th>
                    <vs-th>SKU Detail</vs-th>
                    <vs-th>Order Value ( {{'' | currencySymbol}} )</vs-th>
                    <vs-th>Order Qty.</vs-th>
                </template>

                <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].store_code">
                    {{ data[indextr].store_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].sku_id">
                    {{ data[indextr].sku_id }} - {{ data[indextr].long_description }}
                    </vs-td>
                    
                    <vs-td :data="data[indextr].revenue_sum">
                    {{calculateSkuCtc(data[indextr]) | numFormat('$ 0.00')}}
                    </vs-td>

                    <vs-td :data="data[indextr].oqty">
                    {{ data[indextr].oqty | numFormat }}
                    </vs-td>

                </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </div>
</template>

<script>
import print from 'print-js';
import appConfig from '@/../appConfig.js';

export default{
    props: {
        artefact: { type: Object, required: true },
        service: { type: Object, required: false },
        selected: { type: Array, required: true }
    },
    data() {
        return {
            logo        : require('@/assets/images/logo/'+appConfig.config.logo),
            hasLogoFull : appConfig.config.hasLogoFull,
            fullLogo    : appConfig.config.hasLogoFull ? require('@/assets/images/logo/'+appConfig.config.logoFull) : '',
            hasPartner  : appConfig.config.hasPartner,
            partnerLogo : appConfig.config.hasPartner ? require('@/assets/images/logo/'+appConfig.config.logoPartner) : '',
            showTrigger: true,
            companyDetails: {
                name: 'Microsion Technologies Pvt. Ltd.',
                addressLine1: '9 N. Sherwood Court',
                addressLine2: 'Elyria, OH',
                zipcode: '94203',
                mailId: 'hello@pixinvent.net',
                mobile: '+91 999 999 9999',
            },
            recipientDetails: {
                fullName: 'Peter Stark',
                addressLine1: '8577 West West Drive ',
                addressLine2: 'Holbrook, NY',
                zipcode: '90001',
                mailId: 'peter@mail.com',
                mobile: '+91 988 888 8888',
            },
            invoiceDetails: {
                invoiceNo: '001/2020',
                invoiceDate: new Date(),
            },
            invoiceData: {
                tasks: [
                    {
                        id: 1,
                        task: 'Website Redesign',
                        hours: 60,
                        rate: 15,
                        amount: 90000,
                    },
                    {
                        id: 2,
                        task: 'Newsletter template design',
                        hours: 20,
                        rate: 12,
                        amount: 24000,
                    },
                ],
                subtotal: 114000,
                discountPercentage: 5,
                discountedAmount: 5700,
                total: 108300,
            }
            
        }
    },
    computed: {     
    },
    methods: {
        print() {
            let pdfProps = {
                printable: this.selected,
                type: 'json',
                documentTitle: 'Purchase Trigger',
                properties: [
                    { field: 'sku_id', displayName: 'SKU'},
                    { field: 'long_description', displayName: 'Description'},
                    { field: 'product_category', displayName: 'Category'},
                    { field: 'brand', displayName: 'Brand'},
                    { field: 'oqty', displayName: 'Quantity'}
                ],
                css: 'https://printjs-4de6.kxcdn.com/print.min.css',
                header: '<table class="vx-row leading-loose p-base" style="width: 100%">'+
                '<tr><td><div class="vx-row w-full md:w-1/2 mt-base">'+
                '    <div class="vx-logo cursor-pointer flex items-center" style="float: left">'+
                '        <img src="'+this.logo+'" alt="logo" class="w-10 mr-4" style="width: 100px; display: '+(this.logo? 'block': 'none')+'">'+
                '    </div>'+
                '    <div class="vx-logo cursor-pointer flex items-center" style="float: right">'+
                '        <img src="'+this.partnerLogo+'" alt="partner-logo" class="w-10 mr-4" style="width: 100px; display: '+(this.hasPartner && (this.logo !== this.partnerLogo)? 'block': 'none')+'">'+
                '       <img src="'+this.fullLogo+'" alt="full-logo" style="width: 100px; display: '+(this.hasLogoFull ? 'block': 'none')+'">'+
                '    </div>'+
                '</div></td></tr>'+
                '<tr><td><div class="vx-row w-full md:w-1/2 text-right">'+
                '    <h1># '+this.invoiceDetails.invoiceNo+' @ '+(this.selected ? this.selected[0].store_code : '')+'</h1>'+
                '</div></td></tr>'+
                '<tr><td><div class="vx-row w-full md:w-1/2 mt-12">'+
                '    <h5>Purchase Order Trigger Details</h5>'+
                '    <div class="invoice__recipient-info my-4">'+
                '        <p>No of Items in this PO Trigger   : <span class="font-bold">'+this.selected.length+'</span></p>'+
                '        <p>Total Value of Order             : <span class="font-bold">~</span></p>'+
                '    </div>'+
                '</div></td></tr>'+
            '</div>',
                style: '.custom-h3 { color: red; }',
                gridHeaderStyle: 'color: red;  border: 2px solid #3971A5;',
	            gridStyle: 'border: 2px solid #3971A5;align: right'
                // gridHeaderStyle: 'font-weight: bold;',
                // gridStyle: 'border: 1px solid lightgray; margin-bottom: -1px;'
            };
            // window.print(); 
            printJS(pdfProps);   
        },   
        getData() {
            let dataview = this.selected;
            // if(this.selected && this.selected.length > 1000) {
            //     dataview = this.selected.slice(0, 1000);
            // } 
            
            return dataview;
        },
        checkTriggerStatus() {
            if(this.showTrigger) {
                this.showTrigger = this.selected && this.selected.length > 0;
            }

            return this.showTrigger;
        },
        trigger() {
            this.showTrigger = false;
            this.$vs.notify({title:'Success',text:'Stock Order details notified to the resepective department',color:'success'});
        },
        download() {
            let exploreTagTypes = [];
            let queryType = "";
            let triggerMode = "revenue";

            this.exploreTags = this.bucketAndSortTags(this.exploreTags);

            if (this.exploreTags.length > 0) {
                if (this.guide && this.guide.type) {
                queryType = this.guide.type;
                triggerMode = this.guide.mode ? "revenue" : "quantity";
                } else {
                queryType = this.exploreTags.every(this.isOfTypeB) ? "SDF" : "SCDF";
                queryType = this.exploreTags.every(this.isOfTypeC)
                    ? "CDF"
                    : queryType;
                }

                //Dummy query for dev purpose and later will use recent seaerches from cache to fill this
                let query =
                queryType +
                " - " +
                this.exploreTags[0].tag +
                " vs " +
                this.flatTags(this.exploreTags);

                this.payload = {
                tags: this.exploreTags,
                dateRange: this.dateRange,
                query: query,
                mode: triggerMode,
                type: queryType,
                res: {}
                };
            } else {
                this.payload = {
                tags: this.exploreTags,
                dateRange: this.dateRange,
                query: "",
                mode: triggerMode,
                type: queryType,
                res: {}
                };
            }

            this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT, this.payload);
            this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT_UNIT, this.payload);

            this.filterReset = true;
            //   return this.payload == search.id;
            return true;
        },
        calculateCtc() {
            let ctc = this.selected.map(x => x.revenue_sum).reduce(function(a, b){
                return a + b;
            }, 0);
            return ctc;
        },
        calculateSkuCtc(sku) {
            let ctc = sku.revenue_sum;
            // let ctc = sku.order_quantity > 0 ? ((sku.revenue_sum / sku.order_quantity)*sku.oqty) : 0;
            return ctc;
        }
    },
    mounted() {
        this.checkTriggerStatus();
        // this.invoiceData.tasks = this.selected;
    },
    components: {}
}
</script>